import "../../../css/userManagementPage/UserList.css";
import UserListInfo from "../../../utils/UserListInfo"
import LocationCode from "../../../utils/constants/LocationCode";
import UserListLocationSelector from "./UserListLocationSelector";
import Pagination from "../../footer/Pagination";
import { useEffect, useState } from "react";
import { getDateString, phoneNumberWithHyphen } from "../../../utils/Utils";
import proxy from "../../../utils/Proxy";

let UserList = (props) => {
    let [users, setUsers] = useState([])
    let [listLength, setListLength] = useState(0)
    let [locationToList, setLocationToList] = useState(props.location)
    const ElementCountInOnePage = 10

    let onLocationToListChange = (location) => {
        setLocationToList(location)
        props.onCurrentPageChange(1)
    }
    let setPage = (page) => {
        props.onCurrentPageChange(page)
        document.getElementById("user-list-check-all").checked = false
        document.getElementById("user_list-check-all-pages-user").checked = false
    }
    const changeCheckUsersOfPage = (check) => {
        const checkboxs = document.querySelectorAll(".user-list-checkbox")

        checkboxs.forEach((checkbox) => {
            checkbox.checked = check
        })
        users.forEach(user => {
            if (user.userid === undefined) {
                props.onChangeCheckboxMap(prevState => {
                    if (check) prevState.set("E" + user.lessonid, user)
                    else prevState.delete("E" + user.lessonid)
                    return prevState
                })
            }
            else {
                props.onChangeCheckboxMap(prevState => {
                    if (check) prevState.set(user.userid, user)
                    else prevState.delete(user.userid)
                    return prevState
                })
            }
        })
    }

    const onCheckAllPagesUser = (e) => {
        // 현재 페이지 먼저 반영
        changeCheckUsersOfPage(e.target.checked)
        
        if (e.target.checked) {
            // 서버에 새로 API 요청 및 해당 하는 전체 목록 map에 저장
            const params = {}
            // params.page = props.currentPage
            // params.count = ElementCountInOnePage
            params.name = props.userInput.name
            params.birth = props.userInput.birth
            params.contact = props.userInput.contact
            if (locationToList !== LocationCode.NOT_LOADING)
                params.location = locationToList
            switch (props.userInput.filter) {
                case 1: // 현재 수강생
                    params.order_by = "userid"
                    params.order = "desc"
                    proxy.get("/adminapi/users/current", { params: params }).then(usersResponse => {
                        const userList = usersResponse.data.data
                        userList.forEach(user => {
                            if (user.userid === undefined) {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set("E" + user.lessonid, user)
                                    return prevState
                                })
                            } else {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set(user.userid, user)
                                    return prevState
                                })
                            }
                        })
                    })
                    break;
                case 2: // 레슨 전날 대상자
                    proxy.get("/adminapi/users/day-before-lesson", { params: params }).then(usersResponse => {
                        setListLength(usersResponse.data.length)
                        const userList = usersResponse.data.data
                        userList.forEach(user => {
                            if (user.userid === undefined) {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set("E" + user.lessonid, user)
                                    return prevState
                                })
                            } else {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set(user.userid, user)
                                    return prevState
                                })
                            }
                        })
                    })
                    break;
                case 3: // 재등록 일주일 전
                    proxy.get("/adminapi/users/one-week-before-re-registration", { params: params }).then(usersResponse => {
                        setListLength(usersResponse.data.length)
                        const userList = usersResponse.data.data
                        userList.forEach(user => {
                            if (user.userid === undefined) {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set("E" + user.lessonid, user)
                                    return prevState
                                })
                            } else {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set(user.userid, user)
                                    return prevState
                                })
                            }
                        })
                    })
                    break;
                case 4: // 생일자 정리
                    proxy.get("/adminapi/users/upcoming-birth", { params: params }).then(usersResponse => {
                        const userList = usersResponse.data.data
                        userList.forEach(user => {
                            if (user.userid === undefined) {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set("E" + user.lessonid, user)
                                    return prevState
                                })
                            } else {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set(user.userid, user)
                                    return prevState
                                })
                            }
                        })
                    })
                    break;
                case 5: // 시작일 미정자
                    params.order_by = "userid"
                    params.order = "desc"
                    proxy.get("/adminapi/users/startdate-non-set", { params: params }).then(usersResponse => {
                        const userList = usersResponse.data.data
                        userList.forEach(user => {
                            if (user.userid === undefined) {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set("E" + user.lessonid, user)
                                    return prevState
                                })
                            } else {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set(user.userid, user)
                                    return prevState
                                })
                            }
                        })
                    })
                    break;
                case 6: // 수강 6개월 이상
                    proxy.get("/adminapi/users/register-over-six-months", { params: params }).then(usersResponse => {
                        const userList = usersResponse.data.data
                        userList.forEach(user => {
                            if (user.userid === undefined) {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set("E" + user.lessonid, user)
                                    return prevState
                                })
                            } else {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set(user.userid, user)
                                    return prevState
                                })
                            }
                        })
                    })
                    break;

                default:
                    proxy.get("/adminapi/users", { params: params }).then(usersResponse => {
                        const userList = usersResponse.data.data
                        userList.forEach(user => {
                            if (user.userid === undefined) {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set("E" + user.lessonid, user)
                                    return prevState
                                })
                            } else {
                                props.onChangeCheckboxMap(prevState => {
                                    prevState.set(user.userid, user)
                                    return prevState
                                })
                            }
                        })
                    })
            }
        } else {
            // map 데이터 삭제
            props.onChangeCheckboxMap(new Map())
        }
    }


    let onCheckAll = (e) => {
        changeCheckUsersOfPage(e.target.checked)
    }
    let CheckBox = (props) => {
        let defaultCheck = props.user.userid === undefined ?
            props.checkboxMap.has("E" + props.user.lessonid) :
            props.checkboxMap.has(props.user.userid)
        let [checked, setChecked] = useState(defaultCheck)

        let onCheck = (e) => {
            if (e.target.checked) {
                if (props.user.userid === undefined) {
                    props.onChangeCheckboxMap(prevState => {
                        prevState.set("E" + props.user.lessonid, props.user)
                        return prevState
                    })
                }
                else {
                    props.onChangeCheckboxMap(prevState => {
                        prevState.set(props.user.userid, props.user)
                        return prevState
                    })
                }
                setChecked(true)
            } else {
                if (props.user.userid === undefined) {
                    props.onChangeCheckboxMap(prevState => {
                        prevState.delete("E" + props.user.lessonid)
                        return prevState
                    })
                }
                else {
                    props.onChangeCheckboxMap(prevState => {
                        prevState.delete(props.user.userid)
                        return prevState
                    })
                }
                setChecked(false)
            }

        }
        return (
            <input type="checkbox"
                className="user-list-checkbox"
                onChange={onCheck}
                checked={checked}
            />)
    }

    useEffect(() => {
        const params = {}
        params.page = props.currentPage
        params.count = ElementCountInOnePage
        params.name = props.userInput.name
        params.birth = props.userInput.birth
        params.contact = props.userInput.contact
        if (locationToList !== LocationCode.NOT_LOADING)
            params.location = locationToList
        switch (props.userInput.filter) {
            case 1: // 현재 수강생
                params.order_by = "userid"
                params.order = "desc"
                proxy.get("/adminapi/users/current", { params: params }).then(usersResponse => {
                    setListLength(usersResponse.data.length)
                    let userList = usersResponse.data.data
                    setUsers(userList)
                })
                break;
            case 2: // 레슨 전날 대상자
                proxy.get("/adminapi/users/day-before-lesson", { params: params }).then(usersResponse => {
                    setListLength(usersResponse.data.length)
                    let userList = usersResponse.data.data
                    setUsers(userList)
                })
                break;
            case 3: // 재등록 일주일 전
                proxy.get("/adminapi/users/one-week-before-re-registration", { params: params }).then(usersResponse => {
                    setListLength(usersResponse.data.length)
                    let userList = usersResponse.data.data
                    setUsers(userList)
                })
                break;
            case 4: // 생일자 정리
                proxy.get("/adminapi/users/upcoming-birth", { params: params }).then(usersResponse => {
                    setListLength(usersResponse.data.length)
                    let userList = usersResponse.data.data
                    setUsers(userList)
                })
                break;
            case 5: // 시작일 미정자
                params.order_by = "userid"
                params.order = "desc"
                proxy.get("/adminapi/users/startdate-non-set", { params: params }).then(usersResponse => {
                    setListLength(usersResponse.data.length)
                    let userList = usersResponse.data.data
                    setUsers(userList)
                })
                break;
            case 6: // 수강 6개월 이상
                proxy.get("/adminapi/users/register-over-six-months", { params: params }).then(usersResponse => {
                    setListLength(usersResponse.data.length)
                    let userList = usersResponse.data.data
                    setUsers(userList)
                })
                break;

            default:
                proxy.get("/adminapi/users", { params: params }).then(usersResponse => {
                    setListLength(usersResponse.data.length)
                    let userList = usersResponse.data.data
                    setUsers(userList)
                })
        }
        props.onUpdate()
    }, [locationToList, props, props.location])

    return (
        <div className="user-list-container">
            <div className="user-list-header">
                <div className="user-list-header-content">
                    <div className="user-list-item-wrapper">
                        <label className="user-list-header-tag">
                            <input type="checkbox"
                                id="user-list-check-all"
                                onChange={onCheckAll} />
                        </label>
                    </div>
                    {UserListInfo.label.map((label, index) => {
                        return (
                            index === 1 ?
                                <div className="user-list-item-wrapper" key={label}>
                                    <UserListLocationSelector locationToList={locationToList}
                                        onLocationToListChange={onLocationToListChange}></UserListLocationSelector>
                                </div> :
                                <div className="user-list-item-wrapper" key={label}>
                                    <p className="user-list-header-tag">{label}</p>
                                </div>
                        )
                    })}
                </div>
            </div>
            <div className="user-list-body">
                <div className="user-list-body-content">
                    {users.map((user) => {
                        let birth = new Date(user.birth)

                        return (
                            <div className="user-list-body-item-container"
                                key={user.userid === undefined ?
                                    "lessonid-" + user.lessonid :
                                    "userid-" + user.userid}>
                                <div className="user-list-item-wrapper">
                                    <CheckBox
                                        user={user}
                                        checkboxMap={props.checkboxMap}
                                        onChangeCheckboxMap={props.onChangeCheckboxMap}
                                    />
                                </div>
                                <div className="user-list-item-wrapper">
                                    <p className="user-list-body-item">
                                        {user.userid === undefined ? "외부" : user.userid}
                                    </p>
                                </div>
                                <div className="user-list-item-wrapper">
                                    <p className="user-list-body-item">{LocationCode.text[user.location]}</p>
                                </div>
                                <div className="user-list-item-wrapper">
                                    <p className="user-list-body-item">{user.name}</p>
                                </div>
                                <div className="user-list-item-wrapper">
                                    <p className="user-list-body-item">{user.userid === undefined ? "-" : getDateString(birth)}</p>
                                </div>
                                <div className="user-list-item-wrapper">
                                    <p className="user-list-body-item">{phoneNumberWithHyphen(user.contact)}</p>
                                </div>
                                <div className="user-list-item-wrapper">
                                    {user.userid === undefined ?
                                        <p className="user-list-body-item">-</p> :
                                        <>
                                            <div className="user-list-body-item-button" id={"userDetail" + user.userid}
                                                onClick={props.onDetailButtonClick}><p>{UserListInfo.buttonName[0]}</p></div>
                                            <div className="user-list-body-item-button" id={"lessonuserDetail" + user.userid}
                                                onClick={props.onLessonListButtonClick}><p>{UserListInfo.buttonName[1]}</p></div>
                                            <div className="user-list-body-item-button" id={"paymenthuserDetail" + user.userid}
                                                onClick={props.onPaymentListButtonClick}><p>{UserListInfo.buttonName[2]}</p></div>
                                        </>
                                    }
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="user-list-footer">
                <div className="user-list-footer-checkbox-container">
                    <label className="user-list-footer-checkbox">
                        <input type="checkbox" id="user_list-check-all-pages-user" onClick={onCheckAllPagesUser}/>
                        <p>전체 선택({listLength}건)</p>
                    </label>
                </div>
                <div className="user-list-page-container">
                    <Pagination page={props.currentPage} setPage={setPage}
                        listLength={listLength} countPerPage={ElementCountInOnePage} onChnageCheckboxMap={props.onChangeCheckboxMap} />
                </div>
            </div>
        </div>
    )
};

export default UserList;